import React, { ReactElement } from 'react';
import IconThirdPartyProps from '../IconThirdPartyProps';

export default function IconThirdPartyLink({ className }: IconThirdPartyProps): ReactElement {
    return (
        <svg
            width='18'
            height='18'
            viewBox='0 0 18 18'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            aria-hidden={true}
            className={className}
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M1 0C0.447715 0 0 0.447715 0 1V17C0 17.5523 0.447715 18 1 18H17C17.5523 18 18 17.5523 18 17V13C18 12.4477 17.5523 12 17 12C16.4477 12 16 12.4477 16 13V16H2V2H5C5.55228 2 6 1.55228 6 1C6 0.447715 5.55228 0 5 0H1ZM9.2 0C8.64772 0 8.2 0.447715 8.2 1C8.2 1.55228 8.64772 2 9.2 2H14.5858L4.79289 11.7929C4.40237 12.1834 4.40237 12.8166 4.79289 13.2071C5.18342 13.5976 5.81658 13.5976 6.20711 13.2071L16 3.41421V8.8C16 9.35229 16.4477 9.8 17 9.8C17.5523 9.8 18 9.35229 18 8.8V1C18 0.447715 17.5523 0 17 0H9.2Z'
                fill='#00804F'
            />
        </svg>
    );
}
